export default "__VITE_ASSET__9aOUioQp__"